import { Injectable } from '@angular/core';
import { FileAnswer } from '../../model/FileAnswer';


@Injectable()
export class AnswerControlService {


    //Valor de la respuesta
    public respuesta:any;

    //Cantiad total de items de la sesion
    public totalItems:number;

    //Tipo de item que se esta visualizando
    public itemType:string;

    //i del item que se esta visualizando
    public itemId:number;

    //Sesion actual en la que se encuentra el examen
    public sesion:number;

    //orden del item que se esta visualizando
    public itemOrder:number;

    //Indica si ya se ha iniciado un exmen
    public started:boolean;

    //Almacena la ip publica del cliente
    public publicIp: string;

    //Guarda la direccion mac del cliente (deprecated)
    public macAddress : string;
    
    //Indica el progreso que se lleva en la sesion
    public progress: number;

    /**Indica la Respuesta abierta para un item tipo 4*/
    public respuestaAbierta: string;

    //almacena la respuesta abierta
    public open : string;

    //Variable auxiliar para saber si una respuesta cambia o no
    public previousAnswer : string;


    /**Permite llevar cronómtro para auto guardado*/
    public testChrono: any;

    /**Indica si la respuesta ha sido marcada para revisión*/
    public marcarRespuesta:number

    /** archivo temporal */
    public inputFileTempoAnswer:any = null

    /** extensiones permitidas */
    public acceptExtenFileAnswer:any = null
 
     /**Listas de archivo de respuestas */
	public filesAnswer: Array<FileAnswer> = Array()

    /** Permite guardar temporalmente la respuesta de pregunta abierta */
    public auxOpenAnswer: string = null

    /** Permite guardar temporalmente la respuesta de pregunta abierta */
    public auxOpenAnswerLastLocal: string = null

    //Constructor de la clase
    constructor(){
        this.itemType = 'default';
        this.progress = 0;
    }

    
    public setFileAnswer(filesAnswer: FileAnswer) {
        let positionFind = -1
        this.filesAnswer.forEach( (itemAnswer: FileAnswer, index: number ) => {
           if(itemAnswer.itemId == filesAnswer.itemId && itemAnswer.credencialId == filesAnswer.credencialId
            && itemAnswer.sesion == filesAnswer.sesion) {
                positionFind = index
                return false
           }
        } )

        if( positionFind == -1){
            this.filesAnswer.push(filesAnswer)
        }else {
            this.filesAnswer[positionFind] = filesAnswer 
        }
    }

    public getFile(credencialId: number,
        itemId: number,
        sesion: number) : File   {
         const filesAnswer = this.getFileAnswer(credencialId, itemId, sesion)
         
         return filesAnswer ==  null ? null : filesAnswer.file
        }

    public getFileAnswer(credencialId: number,
        itemId: number,
        sesion: number) : FileAnswer   {
        let findFileAnswer: FileAnswer  = null
        this.filesAnswer.forEach( (itemAnswer: FileAnswer, index: number ) => {
           if(itemAnswer.itemId == itemId && itemAnswer.credencialId == credencialId
            && itemAnswer.sesion == sesion) {
                findFileAnswer = itemAnswer
                return false
           }
        })

        return findFileAnswer
        }

    /*Es invocado cuando se selecciona una opcion de respuesta*/
    public listenAnswerFromChild(value: any) {
        this.respuesta = value.target.value;
        console.log(this.respuesta);
    }

    /*Es invocado cuando se selecciona una opcion de respuesta
      en preguntas de tipo grilla*/
    public listenFromGrid(value : string){
        this.respuesta = value;
    }

    //retorna el valor de la respuesta
    public getRespuesta():any{
        return this.respuesta;
    }

    //establece el valor de la respuesta
    public setRespuesta(respuesta:any){
        this.respuesta = respuesta;
    }
 }
